import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "reactstrap";

import { UPDATE_EMPLOYEE_DETAILS } from "redux/globalData/types";
import { EyeIcon } from "../unAssigned/studentCharges/common";
import APopover from "../common/a-popover";

import { getEmployeeNameFromId } from "./util";

const ViewEmployeeName = ({ empId }) => {
  const dispatch = useDispatch();
  const empDetails = useSelector(
    (state) => state.globalData.employeeInfo || {}
  );

  const [isFetching, setIsFetching] = useState(false);
  const [empName, setEmpName] = useState("");

  useEffect(() => {
    if (empDetails?.[empId]) setEmpName(empDetails[empId]);
  }, []);

  const fetchEmpInfo = async () => {
    setIsFetching(true);

    const response = await getEmployeeNameFromId(empId);
    if (response) {
      dispatch({
        type: UPDATE_EMPLOYEE_DETAILS,
        employeeInfo: { ...empDetails, [empId]: response },
      });
      setEmpName(response);
    }

    setIsFetching(false);
  };

  return (
    <APopover
      buttonComponent={(onClick, styles) => (
        <span
          onClick={(e) => {
            if (!empName) fetchEmpInfo();
            onClick(e);
          }}
          style={{ cursor: "pointer" }}
        >
          <EyeIcon />
        </span>
      )}
      menuComponent={(closeForm) => (
        <>
          <Card
            className="mb-0 regular-body label-color"
            style={{ borderRadius: "12px" }}
          >
            <div className="p-2 text-bold">
              {isFetching ? "Loading..." : empName}
            </div>
          </Card>
        </>
      )}
      transformOriginVertical="center"
      transformOriginHorizontal="left"
    />
  );
};

export default ViewEmployeeName;
